import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';

@Injectable({
  providedIn: 'root'
})
export class QontoService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/qonto`;

  async generateTokens(code: string): Promise<any>{
    return this.request(() => this.http.post(`${this.url}/code`, { code: code } ).toPromise() );
  }
}
